var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAtomicaLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 227,
  height: 27,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1117_8184)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 26.3382C0 24.0268 0 22.8711 0.0877988 21.897C1.03133 11.4285 9.32689 3.1329 19.7954 2.18936C20.7696 2.10156 21.9253 2.10156 24.2366 2.10156H35.4769V26.3382H0Z",
  fill: "url(#paint0_radial_1117_8184)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.5483 3.43937L19.1636 15.5262C23.6864 13.5562 30.7433 14.1856 35.2259 20.0241L35.5483 20.1226L35.5483 26.4697H33.2619C25.6924 16.9713 13.9965 15.951 6.47949 19.1978L29.5643 2.26562H35.5483V3.43937Z",
  fill: "url(#paint1_linear_1117_8184)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M61.8374 20.318L64.016 24.7474H69.1472L58.6268 4.37223H53.553L43.2046 24.7474H48.3931L50.5144 20.318H61.8374ZM56.0756 8.6873L59.8881 16.4316H52.3777L56.0756 8.6873Z",
  fill: "url(#paint2_radial_1117_8184)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.8374 20.318L64.016 24.7474H69.1472L58.6268 4.37223H53.553L43.2046 24.7474H48.3931L50.5144 20.318H61.8374ZM56.0756 8.6873L59.8881 16.4316H52.3777L56.0756 8.6873Z",
  fill: "url(#paint3_radial_1117_8184)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1427 24.7474V20.5466H77.6201C75.6995 20.5466 74.5815 20.4323 73.9796 19.775C73.3202 19.1749 73.1769 17.9747 73.1769 15.86V12.4594H80.1427V8.34438H73.1769V3.85785H69.1064C69.135 4.74372 69.1064 6.08683 68.8484 6.91555C68.533 7.85858 68.1604 8.25865 67.1284 8.45869C66.2971 8.57299 65.0071 8.57299 63.9752 8.57299V12.4594H68.5617V16.6602C68.5617 20.6323 69.3644 22.8899 71.629 23.9758C72.7469 24.4616 74.2949 24.7474 76.3302 24.7474H80.1427Z",
  fill: "url(#paint4_radial_1117_8184)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M80.1427 24.7474V20.5466H77.6201C75.6995 20.5466 74.5815 20.4323 73.9796 19.775C73.3202 19.1749 73.1769 17.9747 73.1769 15.86V12.4594H80.1427V8.34438H73.1769V3.85785H69.1064C69.135 4.74372 69.1064 6.08683 68.8484 6.91555C68.533 7.85858 68.1604 8.25865 67.1284 8.45869C66.2971 8.57299 65.0071 8.57299 63.9752 8.57299V12.4594H68.5617V16.6602C68.5617 20.6323 69.3644 22.8899 71.629 23.9758C72.7469 24.4616 74.2949 24.7474 76.3302 24.7474H80.1427Z",
  fill: "url(#paint5_radial_1117_8184)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M92.0322 25.2903C97.2207 25.2903 100.403 23.7758 101.951 21.1753C102.753 19.8608 103.126 18.3748 103.126 16.6602C103.126 12.8595 101.291 10.2304 97.9947 8.80161C96.332 8.08719 94.4401 7.74427 92.1755 7.74427C87.761 7.74427 84.4071 9.23026 82.6011 11.9165C81.7125 13.2596 81.2538 14.8313 81.2538 16.6602C81.2538 20.2323 82.5724 22.8613 85.7257 24.233C87.331 24.9474 89.4236 25.2903 92.0322 25.2903ZM92.1755 21.3182C87.9903 21.3182 86.213 19.775 86.213 16.6602C86.213 13.2881 88.1909 11.6593 92.2328 11.6593C96.418 11.6593 98.1667 13.3739 98.1667 16.6602C98.1667 19.6893 96.5614 21.3182 92.1755 21.3182Z",
  fill: "url(#paint6_radial_1117_8184)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M92.0322 25.2903C97.2207 25.2903 100.403 23.7758 101.951 21.1753C102.753 19.8608 103.126 18.3748 103.126 16.6602C103.126 12.8595 101.291 10.2304 97.9947 8.80161C96.332 8.08719 94.4401 7.74427 92.1755 7.74427C87.761 7.74427 84.4071 9.23026 82.6011 11.9165C81.7125 13.2596 81.2538 14.8313 81.2538 16.6602C81.2538 20.2323 82.5724 22.8613 85.7257 24.233C87.331 24.9474 89.4236 25.2903 92.0322 25.2903ZM92.1755 21.3182C87.9903 21.3182 86.213 19.775 86.213 16.6602C86.213 13.2881 88.1909 11.6593 92.2328 11.6593C96.418 11.6593 98.1667 13.3739 98.1667 16.6602C98.1667 19.6893 96.5614 21.3182 92.1755 21.3182Z",
  fill: "url(#paint7_radial_1117_8184)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M109.346 24.7474V17.3746C109.346 13.8025 110.664 11.6593 113.846 11.6593C116.197 11.6593 117.286 12.5737 117.716 14.0597C117.945 14.8313 118.06 15.6314 118.06 16.603V24.7474H122.962V17.146C122.962 13.8597 124.28 11.6593 127.233 11.6593C129.526 11.6593 130.759 12.5451 131.246 14.1169C131.476 14.8884 131.619 15.7743 131.619 16.8602V24.7474H136.521V16.0029C136.521 12.7166 135.431 10.2304 133.195 8.80161C132.078 8.11577 130.673 7.77285 128.982 7.77285C125.57 7.77285 123.248 9.43029 122.13 12.0308C121.184 9.40172 119.092 7.74427 115.509 7.74427C112.241 7.74427 110.119 9.43029 109.002 11.8307L108.6 8.34438H104.415V24.7474H109.346Z",
  fill: "url(#paint8_radial_1117_8184)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M109.346 24.7474V17.3746C109.346 13.8025 110.664 11.6593 113.846 11.6593C116.197 11.6593 117.286 12.5737 117.716 14.0597C117.945 14.8313 118.06 15.6314 118.06 16.603V24.7474H122.962V17.146C122.962 13.8597 124.28 11.6593 127.233 11.6593C129.526 11.6593 130.759 12.5451 131.246 14.1169C131.476 14.8884 131.619 15.7743 131.619 16.8602V24.7474H136.521V16.0029C136.521 12.7166 135.431 10.2304 133.195 8.80161C132.078 8.11577 130.673 7.77285 128.982 7.77285C125.57 7.77285 123.248 9.43029 122.13 12.0308C121.184 9.40172 119.092 7.74427 115.509 7.74427C112.241 7.74427 110.119 9.43029 109.002 11.8307L108.6 8.34438H104.415V24.7474H109.346Z",
  fill: "url(#paint9_radial_1117_8184)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M140.739 5.82964C142.861 5.82964 143.893 4.94376 143.893 2.88624C143.893 0.742993 142.775 0 140.739 0C138.733 0 137.586 0.742993 137.586 2.88624C137.586 5.11522 138.503 5.82964 140.739 5.82964ZM138.131 24.7474H143.147V8.34438H138.131V24.7474Z",
  fill: "url(#paint10_radial_1117_8184)"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M140.739 5.82964C142.861 5.82964 143.893 4.94376 143.893 2.88624C143.893 0.742993 142.775 0 140.739 0C138.733 0 137.586 0.742993 137.586 2.88624C137.586 5.11522 138.503 5.82964 140.739 5.82964ZM138.131 24.7474H143.147V8.34438H138.131V24.7474Z",
  fill: "url(#paint11_radial_1117_8184)"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M183.896 20.861L184.326 24.7474H188.282V14.5455C188.282 10.9734 186.791 9.14453 183.896 8.34438C182.434 7.97289 180.685 7.77285 178.535 7.77285C172.2 7.77285 168.674 9.68748 168.13 14.0597H173.146C173.29 12.7452 173.978 11.945 175.64 11.5735C176.443 11.3449 177.532 11.2592 178.965 11.2592C181.345 11.2592 182.635 11.7164 183.179 12.3737C183.495 12.7166 183.609 13.0595 183.609 13.431V13.4596C183.609 14.174 183.151 14.5455 181.803 14.7456C181.144 14.8599 180.198 14.917 178.965 15.0027C175.44 15.2028 173.49 15.4314 172.143 15.7743C171.484 15.9743 170.882 16.1744 170.337 16.4316C168.531 17.2603 167.728 18.6891 167.728 20.6038V20.6323C167.728 23.7758 170.222 25.2903 174.752 25.2903C179.51 25.2903 182.549 23.4614 183.896 20.861ZM176.214 21.8611C173.806 21.8611 172.888 21.2896 172.888 20.2037V20.1751C172.888 19.5179 173.232 19.032 173.92 18.6891C174.809 18.2605 176.242 18.0319 179.395 17.889C182.09 17.7461 183.237 17.346 183.667 16.7745V16.8888C183.667 18.5462 182.319 20.1465 180.055 21.1181C178.937 21.6039 177.675 21.8611 176.214 21.8611Z",
  fill: "url(#paint12_radial_1117_8184)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M183.896 20.861L184.326 24.7474H188.282V14.5455C188.282 10.9734 186.791 9.14453 183.896 8.34438C182.434 7.97289 180.685 7.77285 178.535 7.77285C172.2 7.77285 168.674 9.68748 168.13 14.0597H173.146C173.29 12.7452 173.978 11.945 175.64 11.5735C176.443 11.3449 177.532 11.2592 178.965 11.2592C181.345 11.2592 182.635 11.7164 183.179 12.3737C183.495 12.7166 183.609 13.0595 183.609 13.431V13.4596C183.609 14.174 183.151 14.5455 181.803 14.7456C181.144 14.8599 180.198 14.917 178.965 15.0027C175.44 15.2028 173.49 15.4314 172.143 15.7743C171.484 15.9743 170.882 16.1744 170.337 16.4316C168.531 17.2603 167.728 18.6891 167.728 20.6038V20.6323C167.728 23.7758 170.222 25.2903 174.752 25.2903C179.51 25.2903 182.549 23.4614 183.896 20.861ZM176.214 21.8611C173.806 21.8611 172.888 21.2896 172.888 20.2037V20.1751C172.888 19.5179 173.232 19.032 173.92 18.6891C174.809 18.2605 176.242 18.0319 179.395 17.889C182.09 17.7461 183.237 17.346 183.667 16.7745V16.8888C183.667 18.5462 182.319 20.1465 180.055 21.1181C178.937 21.6039 177.675 21.8611 176.214 21.8611Z",
  fill: "url(#paint13_radial_1117_8184)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M194.451 25.1475C195.712 25.1475 196.486 24.5759 196.486 23.2614C196.486 21.9469 195.827 21.3182 194.479 21.3182C193.103 21.3182 192.415 21.9469 192.415 23.2614C192.415 24.6045 193.103 25.1475 194.451 25.1475Z",
  fill: "url(#paint14_radial_1117_8184)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M194.451 25.1475C195.712 25.1475 196.486 24.5759 196.486 23.2614C196.486 21.9469 195.827 21.3182 194.479 21.3182C193.103 21.3182 192.415 21.9469 192.415 23.2614C192.415 24.6045 193.103 25.1475 194.451 25.1475Z",
  fill: "url(#paint15_radial_1117_8184)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M217.34 19.5437L217.544 24.768H219.466L219.524 13.2747C219.524 9.82089 216.904 7.6151 210.498 7.6151C204.035 7.6151 200.57 9.67577 199.988 14.2325H202.317C202.812 10.8948 205.054 9.38553 210.644 9.38553C214.05 9.38553 215.885 10.1692 216.671 11.214C217.107 11.7655 217.282 12.2589 217.282 12.8103C217.282 14.0293 216.554 14.5517 214.633 14.8129C213.672 14.958 212.391 15.0741 210.76 15.1902C207.238 15.3934 205.054 15.7127 203.569 16.206C202.841 16.4382 202.201 16.7575 201.648 17.1058C200.308 17.9475 199.639 19.1955 199.639 20.8208V20.8498C199.639 23.607 201.415 25.2904 206.248 25.2904C210.295 25.2904 213.235 24.1295 215.186 22.388C216.176 21.5464 216.875 20.5596 217.34 19.5437ZM206.743 23.578C203.278 23.578 202.084 22.388 202.084 20.7047V20.6757C202.084 19.6889 202.492 18.9052 203.307 18.2957C204.472 17.396 206.568 16.9316 210.964 16.6704C215.011 16.4382 216.671 15.9739 217.34 15.1322V16.3512C217.34 18.0345 216.35 19.7469 214.516 21.1981C212.682 22.6493 210.062 23.578 206.743 23.578Z",
  fill: "url(#paint16_radial_1117_8184)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M217.34 19.5437L217.544 24.768H219.466L219.524 13.2747C219.524 9.82089 216.904 7.6151 210.498 7.6151C204.035 7.6151 200.57 9.67577 199.988 14.2325H202.317C202.812 10.8948 205.054 9.38553 210.644 9.38553C214.05 9.38553 215.885 10.1692 216.671 11.214C217.107 11.7655 217.282 12.2589 217.282 12.8103C217.282 14.0293 216.554 14.5517 214.633 14.8129C213.672 14.958 212.391 15.0741 210.76 15.1902C207.238 15.3934 205.054 15.7127 203.569 16.206C202.841 16.4382 202.201 16.7575 201.648 17.1058C200.308 17.9475 199.639 19.1955 199.639 20.8208V20.8498C199.639 23.607 201.415 25.2904 206.248 25.2904C210.295 25.2904 213.235 24.1295 215.186 22.388C216.176 21.5464 216.875 20.5596 217.34 19.5437ZM206.743 23.578C203.278 23.578 202.084 22.388 202.084 20.7047V20.6757C202.084 19.6889 202.492 18.9052 203.307 18.2957C204.472 17.396 206.568 16.9316 210.964 16.6704C215.011 16.4382 216.671 15.9739 217.34 15.1322V16.3512C217.34 18.0345 216.35 19.7469 214.516 21.1981C212.682 22.6493 210.062 23.578 206.743 23.578Z",
  fill: "url(#paint17_radial_1117_8184)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M225.31 5.23518C226.446 5.23518 226.912 4.68373 226.912 3.58084C226.912 2.47795 226.417 1.95553 225.31 1.95553C224.262 1.95553 223.709 2.47795 223.709 3.58084C223.709 4.79983 224.175 5.23518 225.31 5.23518ZM224.088 24.768H226.417V8.31167H224.088V24.768Z",
  fill: "url(#paint18_radial_1117_8184)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M225.31 5.23518C226.446 5.23518 226.912 4.68373 226.912 3.58084C226.912 2.47795 226.417 1.95553 225.31 1.95553C224.262 1.95553 223.709 2.47795 223.709 3.58084C223.709 4.79983 224.175 5.23518 225.31 5.23518ZM224.088 24.768H226.417V8.31167H224.088V24.768Z",
  fill: "url(#paint19_radial_1117_8184)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.08 21.5754C165.675 20.7567 166.094 19.8207 166.326 18.7885H160.918C160.209 20.4343 158.564 21.3182 155.448 21.3182C151.263 21.3182 149.486 19.775 149.486 16.6602C149.486 13.2881 151.464 11.6593 155.506 11.6593C158.503 11.6593 160.179 12.4924 160.918 14.1588H166.292C165.246 10.0432 161.536 7.74427 155.448 7.74427C151.034 7.74427 147.68 9.23026 145.874 11.9165C144.985 13.2596 144.527 14.8313 144.527 16.6602C144.527 20.2323 145.845 22.8613 148.998 24.233C150.604 24.9474 152.696 25.2903 155.305 25.2903C160.235 25.2903 163.389 23.9187 165.08 21.5754Z",
  fill: "url(#paint20_radial_1117_8184)"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.08 21.5754C165.675 20.7567 166.094 19.8207 166.326 18.7885H160.918C160.209 20.4343 158.564 21.3182 155.448 21.3182C151.263 21.3182 149.486 19.775 149.486 16.6602C149.486 13.2881 151.464 11.6593 155.506 11.6593C158.503 11.6593 160.179 12.4924 160.918 14.1588H166.292C165.246 10.0432 161.536 7.74427 155.448 7.74427C151.034 7.74427 147.68 9.23026 145.874 11.9165C144.985 13.2596 144.527 14.8313 144.527 16.6602C144.527 20.2323 145.845 22.8613 148.998 24.233C150.604 24.9474 152.696 25.2903 155.305 25.2903C160.235 25.2903 163.389 23.9187 165.08 21.5754Z",
  fill: "url(#paint21_radial_1117_8184)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.05329 9.08499) rotate(60.6921) scale(19.7857 28.9406)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3F3F3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1117_8184",
  x1: 9.96305,
  y1: 17.14,
  x2: 37.4297,
  y2: 11.5346,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.411136,
  stopColor: "#D9D9D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D9D9D9",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint17_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint18_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(84.9063 7.28706) rotate(19.7469) scale(53.2854 58.0652)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.432292,
  stopColor: "#C9C9C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#737373"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint21_radial_1117_8184",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(213.124 -3.92409) rotate(170.244) scale(172.412 219.407)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#181818"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1117_8184"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 26.3382C0 24.0268 0 22.8711 0.0877988 21.897C1.03133 11.4285 9.32689 3.1329 19.7954 2.18936C20.7696 2.10156 21.9253 2.10156 24.2366 2.10156H35.4769V26.3382H0Z",
  fill: "white"
})))));
export { SvgAtomicaLogo as ReactComponent };